module.exports = __webpack_public_path__ + "img/tooltipImg.0da86c79.svg";